import { gql } from "@apollo/client";

export const getVideoUploadURLQuery = gql`
  query getVideoUploadURL($fileName: String!, $fileSize: Float!) {
    getVideoUploadURL(fileName: $fileName fileSize: $fileSize) {
      uploadURL
      cloudflareId
    }
  }
`;
